module.exports = {
  background: {
    color: {
      base: 'color.gray40',
    },
  },
  font: {
    color: {
      base: 'font.color.primary',
    },
  },
};
